
import React from 'react';
import RichTextEditor from './RichTextEditor';
import { saveBusinessSetting } from '@/utils/businessService';

interface PrivacyPolicyEditorProps {
  initialContent: string;
  onSaved?: () => void;
}

const PrivacyPolicyEditor: React.FC<PrivacyPolicyEditorProps> = ({ initialContent, onSaved }) => {
  const handleSave = async (content: string) => {
    await saveBusinessSetting('privacyPolicy', content);
  };

  return (
    <RichTextEditor
      title="Privacy Policy"
      initialContent={initialContent}
      onSave={handleSave}
      onSaved={onSaved}
    />
  );
};

export default PrivacyPolicyEditor;
